module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("外教异动风险监测")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "精确匹配"
    },
    model: {
      value: (_vm.queryParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchId", $$v)
      },
      expression: "queryParam.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索"
    },
    model: {
      value: (_vm.queryParam.tchName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "tchName", $$v)
      },
      expression: "queryParam.tchName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "外管"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.queryParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "studyAdviserId", _vm._n($$v))
      },
      expression: "queryParam.studyAdviserId"
    }
  }, _vm._l((_vm.studyAdviserList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "风险等级"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.level),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "level", $$v)
      },
      expression: "queryParam.level"
    }
  }, _vm._l((_vm.levelOptions), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "只看异动"
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.queryParam.onlyAnomaly),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "onlyAnomaly", $$v)
      },
      expression: "queryParam.onlyAnomaly"
    }
  }, [_vm._v("风险分≥异动线")])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师分类"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": ""
    },
    model: {
      value: (_vm.queryParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "channel", $$v)
      },
      expression: "queryParam.channel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "lg": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "统计窗口"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "placeholder": "选择月份",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onStatMonthChange
    },
    model: {
      value: (_vm.monthDate),
      callback: function($$v) {
        _vm.monthDate = $$v
      },
      expression: "monthDate"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "lg": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "全周期"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择时间范围",
      "clearable": ""
    },
    on: {
      "on-change": _vm.onWindowChange
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.openRuleModal
    }
  }, [_vm._v("规则设置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "level-bar"
  }, _vm._l((_vm.levelOptions), function(item) {
    return _c('span', {
      key: item,
      staticClass: "level-item",
      class: {
        'level-item-active': _vm.queryParam.level === item
      },
      on: {
        "click": function($event) {
          return _vm.filterByLevel(item)
        }
      }
    }, [_c('span', {
      staticClass: "level-dot",
      style: ({
        background: _vm.levelColor(item)
      })
    }), _vm._v("\n      " + _vm._s(item) + "："), _c('b', [_vm._v(_vm._s(_vm.levelCounts[item] || 0))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "list-table"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.dataList,
      "loading": _vm.searchLoading,
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "12px",
      "text-align": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.totalCount,
      "current": _vm.queryParam.pageIndex,
      "page-size": _vm.queryParam.pageSize,
      "show-total": "",
      "show-sizer": ""
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "异动风险规则设置",
      "width": "1100",
      "mask-closable": false,
      "transfer": ""
    },
    model: {
      value: (_vm.showRuleModal),
      callback: function($$v) {
        _vm.showRuleModal = $$v
      },
      expression: "showRuleModal"
    }
  }, [(_vm.ruleLoading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ruleConfig) ? _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "回溯月数"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 6,
      "max": 36,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.lookbackMonths),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "lookbackMonths", $$v)
      },
      expression: "ruleConfig.lookbackMonths"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "升级单条权重"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "max": 20,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.upgradeWeight),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "upgradeWeight", $$v)
      },
      expression: "ruleConfig.upgradeWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "异动线"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.anomalyScore),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "anomalyScore", $$v)
      },
      expression: "ruleConfig.anomalyScore"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "高危 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.high),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "high", $$v)
      },
      expression: "ruleConfig.high"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "中危 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.medium),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "medium", $$v)
      },
      expression: "ruleConfig.medium"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "观察 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.watch),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "watch", $$v)
      },
      expression: "ruleConfig.watch"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "提示 ≥"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 1,
      "step": 1
    },
    model: {
      value: (_vm.ruleConfig.hint),
      callback: function($$v) {
        _vm.$set(_vm.ruleConfig, "hint", $$v)
      },
      expression: "ruleConfig.hint"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rule-table-wrap"
  }, [_c('table', {
    staticClass: "rule-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v("编号")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("分组")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "140px"
    }
  }, [_vm._v("规则")]), _vm._v(" "), _c('th', [_vm._v("判定说明")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "230px"
    }
  }, [_vm._v("参数")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("权重")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "90px"
    }
  }, [_vm._v("互斥组")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v("启用")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ruleConfig.rules), function(rule) {
    return _c('tr', {
      key: rule.code,
      class: {
        'rule-disabled': !rule.enabled
      }
    }, [_c('td', [_vm._v(_vm._s(rule.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rule.groupName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rule.name))]), _vm._v(" "), _c('td', {
      staticClass: "rule-desc"
    }, [_vm._v(_vm._s(rule.desc))]), _vm._v(" "), _c('td', [(!rule.params || !rule.params.length) ? _c('span', {
      staticClass: "rule-muted"
    }, [_vm._v("无")]) : _vm._e(), _vm._v(" "), _vm._l((rule.params), function(p) {
      return _c('div', {
        key: p.key,
        staticClass: "rule-param"
      }, [_c('span', {
        staticClass: "rule-param-label"
      }, [_vm._v(_vm._s(p.label))]), _vm._v(" "), _c('InputNumber', {
        staticStyle: {
          "width": "80px"
        },
        attrs: {
          "min": 0,
          "step": _vm.paramStep(p),
          "size": "small"
        },
        model: {
          value: (p.value),
          callback: function($$v) {
            _vm.$set(p, "value", $$v)
          },
          expression: "p.value"
        }
      })], 1)
    })], 2), _vm._v(" "), _c('td', [_c('InputNumber', {
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "min": 0,
        "max": 20,
        "step": 1,
        "size": "small"
      },
      model: {
        value: (rule.weight),
        callback: function($$v) {
          _vm.$set(rule, "weight", $$v)
        },
        expression: "rule.weight"
      }
    })], 1), _vm._v(" "), _c('td', [_c('Input', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (rule.mutexGroup),
        callback: function($$v) {
          _vm.$set(rule, "mutexGroup", $$v)
        },
        expression: "rule.mutexGroup"
      }
    })], 1), _vm._v(" "), _c('td', [_c('i-switch', {
      attrs: {
        "size": "small"
      },
      model: {
        value: (rule.enabled),
        callback: function($$v) {
          _vm.$set(rule, "enabled", $$v)
        },
        expression: "rule.enabled"
      }
    })], 1)])
  }), 0)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showRuleModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "loading": _vm.ruleResetLoading
    },
    on: {
      "click": _vm.resetRules
    }
  }, [_vm._v("恢复默认")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.ruleSaveLoading,
      "disabled": !_vm.ruleConfig
    },
    on: {
      "click": _vm.saveRules
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.leaveDetailTitle,
      "width": "960",
      "transfer": ""
    },
    model: {
      value: (_vm.showLeaveDetailModal),
      callback: function($$v) {
        _vm.showLeaveDetailModal = $$v
      },
      expression: "showLeaveDetailModal"
    }
  }, [(_vm.leaveDetail) ? _c('div', {
    staticClass: "detail-summary"
  }, [_vm._v("\n      区间：" + _vm._s(_vm.leaveDetail.windowStart || '—') + " ~ " + _vm._s(_vm.leaveDetail.windowEnd || '—') + "\n      "), _c('span', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v(_vm._s(_vm.leaveDetailValueText))])]) : _vm._e(), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.leaveColumns,
      "data": _vm.leaveDetailLeaves,
      "loading": _vm.leaveDetailLoading,
      "size": "small",
      "stripe": ""
    }
  }), _vm._v(" "), (_vm.leaveDetailMetric === 'singleMax') ? _c('div', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "detail-sub-title"
  }, [_vm._v("受影响课节")]), _vm._v(" "), _c('Table', {
    attrs: {
      "columns": _vm.lessonColumns,
      "data": _vm.leaveDetailLessons,
      "loading": _vm.leaveDetailLoading,
      "size": "small",
      "stripe": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.showLeaveDetailModal = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    attrs: {
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchInfoId
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa068bfc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchRiskWarningList.vue
// module id = 1927
// module chunks = 8